import { render, staticRenderFns } from "./warnSettingEdit.vue?vue&type=template&id=27934649&scoped=true&"
import script from "./warnSettingEdit.vue?vue&type=script&lang=js&"
export * from "./warnSettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./warnSettingEdit.vue?vue&type=style&index=0&id=27934649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27934649",
  null
  
)

export default component.exports